/*
  KP: THE PERSONALISATION BOX on personalised products: a text box above Add to Cart
  ("Enter your personalisation") whose words go through on the order as a line called
  "Personalisation". It replaces the Infinite Options app (by ShopPad), which drew the
  same box and saved it under the same name, so orders look the same as before.

  Which products: every product with the tag CUSTOM (the same rule the app used).
  snippets/theme-globals.liquid checks the tag and, for those products only, loads this
  file and gives it its words (window.KP_PERSONALISE): the label, the help line, the
  message shown when the box is left empty, and the name of the line on the order.
  Change the words there. Styles: assets/kp-personalise.css.

  The box must be filled in: with it empty, Add to Cart does nothing, the message shows
  and the page moves to the box. The fast checkout buttons under Add to Cart (Shop Pay,
  "Buy it now") are hidden until something is typed, because they skip that check.

  WHILE THE INFINITE OPTIONS APP IS STILL INSTALLED this does nothing and the app draws
  its own box, so there are never two. Once the app is uninstalled, this takes over by
  itself. (The app's two other option sets, a phone "Model" list and gift options, were
  not attached to any product and have not been rebuilt.)
*/
(function () {
  'use strict';

  var cfg = window.KP_PERSONALISE;
  if (!cfg || !cfg.name) return;

  // Is the Infinite Options app still on this page? It either has its holder in the
  // page already, or its script ("customizery.js") is in Shopify's list of app scripts.
  function appIsOn() {
    if (document.getElementById('infiniteoptions-container')) return true;
    var scripts = document.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].textContent.indexOf('customizery.js') !== -1) return true;
    }
    return false;
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function draw(form) {
    var block = form.closest('.product-form') || form;
    if (!block.parentNode || block.parentNode.querySelector('.kp-personalise')) return;

    var formId = form.getAttribute('id');
    var box = document.createElement('div');
    box.className = 'kp-personalise product__block product__block--medium';
    box.innerHTML =
      '<label class="kp-personalise__label" for="kp-personalise-input">' + escapeHtml(cfg.label) + '</label>' +
      '<input class="kp-personalise__input" id="kp-personalise-input" type="text" autocomplete="off"' +
      ' name="properties[' + escapeHtml(cfg.name) + ']"' +
      (formId ? ' form="' + escapeHtml(formId) + '"' : '') +
      ' aria-describedby="kp-personalise-help" aria-required="true">' +
      '<p class="kp-personalise__error" role="alert" hidden>' + escapeHtml(cfg.error) + '</p>' +
      (cfg.help ? '<p class="kp-personalise__help" id="kp-personalise-help">' + escapeHtml(cfg.help) + '</p>' : '');

    // With no id on the form to point at, the box has to sit inside the form itself.
    if (formId) {
      block.parentNode.insertBefore(box, block);
    } else {
      form.insertBefore(box, form.firstChild);
    }

    var input = box.querySelector('.kp-personalise__input');
    var error = box.querySelector('.kp-personalise__error');

    var filled = function () {
      return input.value.replace(/\s+/g, '') !== '';
    };
    var mark = function () {
      // Fast checkout buttons only while there is something typed.
      block.classList.toggle('kp-personalise-empty', !filled());
      if (filled()) {
        error.hidden = true;
        box.classList.remove('has-error');
      }
    };
    var check = function () {
      if (filled()) return true;
      error.hidden = false;
      box.classList.add('has-error');
      try {
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
      return false;
    };
    var stop = function (event) {
      if (check()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    input.addEventListener('input', mark);
    mark();

    // Before anything else hears of it: a press on Add to Cart (the main button or the
    // bar at the bottom of the screen on phones), and the form being sent.
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var button = target.closest('[data-add-to-cart], [class*="sticky-atc"] button, [class*="sticky-atc__button"]');
        if (!button || button.closest('.quick-product-modal')) return;
        stop(event);
      },
      true
    );
    form.addEventListener('submit', stop, true);
  }

  function run() {
    if (appIsOn()) return;
    var forms = document.querySelectorAll('.product-form form[action*="/cart/add"], form.product-form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('.quick-product-modal')) continue;
      draw(forms[i]);
      return;
    }
  }

  // For checking by hand while the app is still installed: KP_PERSONALISE.draw(form).
  cfg.draw = draw;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
